import React from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { ROUTE_HOME, ROUTE_LOGIN } from "./constants/routes";
import AdminLoginPage from "./components/Login/AdminLoginPage";
import ProtectedAdminRoute from "./components/Auth/ProtectedAdminRoute";
import AdminLayout from "./components/Layout/AdminLayout";
import AdminDashboardPage from "./components/Dashboard/AdminDashboardPage";
import AddAdminUserPage from "./components/AdminUsers/AddAdminUserPage";
import AdminUserListPage from "./components/AdminUsers/AdminUserListPage";
import AdminUserDetailPage from "./components/AdminUsers/AdminUserDetailPage";
import CompanyListView from "./components/Companies/CompanyListView";
import CompanyDetailView from "./components/Companies/CompanyDetailView";
import MembershipHome from "./components/Membership/MembershipHome";
import MembershipManagementView from "./components/Membership/MembershipManagementView";
import PlanListView from "./components/Plans/PlanListView";
import PlanDetailView from "./components/Membership/PlanDetailView";
import FeatureDetailView from "./components/Membership/FeatureDetailView";
import BillingCycleDetailView from "./components/Membership/BillingCycleDetailView";
import PlanPricingDetailView from "./components/Membership/PlanPricingDetailView";
import SubscriptionListTableView from "./components/Subscriptions/SubscriptionListTableView";
import SubscriptionDetailView from "./components/Subscriptions/SubscriptionDetailView";
import PaymentList from "./components/Payments/PaymentList";
import OrderSummary from "./components/Checkout/OrderSummary";
import PaymentOptions from "./components/Checkout/PaymentOptions";
import SubscriptionSuccess from "./components/Checkout/SubscriptionSuccess";

/**
 * Admin Portal app. Login is public; all other routes require super-admin auth.
 */
const App = () => {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route
        path={ROUTE_LOGIN}
        element={
          <AdminLoginPage
            onSuccess={() => navigate(ROUTE_HOME)}
            onAccessDenied={() => {}}
          />
        }
      />

      <Route path={ROUTE_HOME} element={<ProtectedAdminRoute />}>
        <Route element={<AdminLayout />}>
          <Route index element={<AdminDashboardPage />} />
          <Route path="add-admin-user" element={<AddAdminUserPage />} />
          <Route path="admin-users" element={<AdminUserListPage />} />
          <Route path="admin-users/:userId" element={<AdminUserDetailPage />} />
          <Route path="companies" element={<CompanyListView />} />
          <Route path="companies/:companyId" element={<CompanyDetailView />} />
          <Route path="membership" element={<MembershipManagementView />} />
          <Route path="plans" element={<PlanListView />} />
          <Route path="plans/:planId" element={<PlanDetailView />} />
          <Route
            path="plan-pricing/:planId/:planPricingId"
            element={<PlanPricingDetailView />}
          />
          <Route path="features/:featureCode" element={<FeatureDetailView />} />
          <Route
            path="billing-cycles/:billingCycleId"
            element={<BillingCycleDetailView />}
          />
          <Route path="subscriptions" element={<SubscriptionListTableView />} />
          <Route
            path="subscriptions/:subscriptionId"
            element={<SubscriptionDetailView />}
          />
          <Route path="payments" element={<PaymentList />} />
          <Route path="order-summary" element={<OrderSummary />} />
          <Route path="checkout" element={<PaymentOptions />} />
          <Route path="success" element={<SubscriptionSuccess />} />
          <Route path="membership-home" element={<MembershipHome />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to={ROUTE_HOME} replace />} />
    </Routes>
  );
};

export default App;
